export const config = {
  api: {
    url: 'https://api.lonard.org'
  },
  localStoragePrefix: 'lonard',
  googleMap: {
    url: 'https://maps.googleapis.com/maps/api',
    apiKey: 'AIzaSyDxyo-9p0jSsAozc1_yEjCa6oHqqO4UjKo'
  },
  images: {
    maxSize: 6291456 // octets
  },
  pagination: {
    itemsPerPage: 10,
    maxPagesDisplayed: 5 // nombre impair pour un affichage agréable
  },
  debounceTime: 600,
  upcomingDays: 16
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/config/config.ts